import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App.js';
import * as serviceWorker from './serviceWorker';
import {getQueryString, isNull} from '@/assets/js/string'
import VConsole from 'vconsole'

var debug = getQueryString('debug')
if (debug == 'console') {
  let vconsole = new VConsole()
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
